import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import MachineForm from "../../components/Machines/MachinesForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";

const MachinesCreate = ({classes, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('qualifications.new_machine')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('schedules.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Paper>
            <CardContent>
                <MachineForm
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default MachinesCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/machines/Create.jsx